<dx-data-grid [dataSource]="reviews"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true"
              [showRowLines]="true"
              [hoverStateEnabled]="true"
              (onRowClick)="editRating($event.data)"
              [showBorders]="true"
              [wordWrapEnabled]="true">
    <!-- Options -->
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-column-chooser [enabled]="true"> </dxo-data-grid-column-chooser>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>

    <!-- Columns -->
    <dxi-data-grid-column caption="Organisation"
                          dataField="organisationId"
                          cellTemplate="orgCellTemplate"
                          dataType="number"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Organisation name"
                          dataField="organisationName"
                          dataType="string"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Submission date"
                          dataField="submittedOn"
                          dataType="date"
                          [format]="dateFormat"
                          sortOrder="desc"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Workflow ID"
                          dataField="workflowId"
                          dataType="string"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Pathway"
                          dataField="workflowName"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Liked"
                          dataField="liked"
                          width="150"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Improve on"
                          dataField="improveOn"
                          width="150"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Person"
                          dataField="partitionKey"
                          dataType="string"
                          cellTemplate="personCellTemplate"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Rating"
                          dataField="rating"
                          dataType="number"
                          cellTemplate="ratingCellTemplate"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Our comment"
                          dataField="comment"
                          width="200"
                          cellTemplate="commentCellTemplate"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Status"
                          dataField="status"
                          dataType="string"
                          cellTemplate="statusCellTemplate"> </dxi-data-grid-column>

    <div *dxTemplate="let item of 'orgCellTemplate'">
        <adapt-link-organisation [organisation]="getOrganisation(item.data.organisationId)"> </adapt-link-organisation>
    </div>

    <div *dxTemplate="let item of 'personCellTemplate'">
        <adapt-link-person [personId]="item.data.partitionKey"></adapt-link-person>
    </div>

    <div *dxTemplate="let item of 'ratingCellTemplate'">
        <adapt-rating-stars disabled
                            compact
                            [(rating)]="item.data.rating"></adapt-rating-stars>
    </div>

    <div *dxTemplate="let item of 'statusCellTemplate'">
        @if (item.data.status !== undefined) {
            <div class="badge round-pill"
                 [ngClass]="pathwayReviewService.getStatus(item.data.status)">
                {{ item.data.status }}
            </div>
        }
    </div>

    <div *dxTemplate="let item of 'commentCellTemplate'"
         [froalaView]="item.data.comment"></div>
</dx-data-grid>
